































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Message, MessagesApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  computed: mapGetters({
    messagesApi: 'messagesApi'
  })
})
export default class QuickMessagePicker extends Vue {
  private messagesApi!: MessagesApi;
  private messages!: Message[];

  private loadingMessages = true;
  private popoverOpen = false;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false })
  private messageDirection!: string;

  get Messages(): Message[] {
    return this.messages;
  }

  private async mounted() {
    this.loadMessages();
  }

  private async loadMessages() {
    this.loadingMessages = true;
    this.messages = await this.messagesApi.messagesQuery({
      propertyId: this.propertyId,
      messageDirection: this.messageDirection
    });
    this.loadingMessages = false;
  }

  private messageClickedHandler(message: Message) {
    this.$emit('message-clicked', message.messageText);
    this.popoverOpen = false;
  }
}
